export function getParams (state){
    return state.params
}

export function getTypePerson (state){
    return state.typePerson
}



// WEBPACK FOOTER //
// ./src/modules/prospective-client/getters.js